import type { EventItem, OrderRegistrationForm, RegistrationFormResponses } from "../types/api";

export const STORYTELLING_MASTERCLASS_SLUG = "storytelling-masterclass-with-uncle-ebo-whyte";
export const STORYTELLING_MASTERCLASS_FORM_TITLE =
  "Storytelling Masterclass with Uncle Ebo Whyte registration";

export const emptyMasterclassRegistration: RegistrationFormResponses = {
  fullName: "",
  gender: "",
  phone: "",
  email: "",
  occupation: "",
  institution: "",
  attendedMasterclass: "",
  attendedMasterclassList: "",
  goals: "",
};

export function isStorytellingMasterclassEvent(event?: Pick<EventItem, "slug" | "title"> | null) {
  if (!event) return false;
  const slug = event.slug?.toLowerCase() ?? "";
  const title = event.title?.toLowerCase() ?? "";

  return (
    slug === STORYTELLING_MASTERCLASS_SLUG ||
    (title.includes("storytelling masterclass") && title.includes("ebo whyte"))
  );
}

export function masterclassRegistrationStorageKey(eventId: string) {
  return `aan-masterclass-registration:${eventId}`;
}

export function buildMasterclassRegistrationForm(
  responses: RegistrationFormResponses
): OrderRegistrationForm {
  return {
    formKey: STORYTELLING_MASTERCLASS_SLUG,
    formTitle: STORYTELLING_MASTERCLASS_FORM_TITLE,
    responses,
  };
}

export function loadMasterclassRegistration(eventId: string): OrderRegistrationForm | null {
  try {
    const raw = window.sessionStorage.getItem(masterclassRegistrationStorageKey(eventId));
    return raw ? (JSON.parse(raw) as OrderRegistrationForm) : null;
  } catch {
    return null;
  }
}

export function saveMasterclassRegistration(eventId: string, responses: RegistrationFormResponses) {
  const payload = buildMasterclassRegistrationForm(responses);
  window.sessionStorage.setItem(masterclassRegistrationStorageKey(eventId), JSON.stringify(payload));
  return payload;
}

